"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DownloadIcon = void 0;
const react_1 = __importDefault(require("react"));
const SvgIcon_1 = __importDefault(require("@mui/material/SvgIcon"));
const DownloadIcon = (_a) => {
    var { width = 24, height = 24, color = 'currentColor' } = _a, props = __rest(_a, ["width", "height", "color"]);
    return (react_1.default.createElement(SvgIcon_1.default, Object.assign({ height: height, width: width, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), react_1.default.createElement("path", { d: "M8 8L6 8C3.79086 8 2 9.79086 2 12L2 17C2 19.2091 3.79086 21 6 21L18 21C20.2091 21 22 19.2091 22 17L22 12C22 9.79086 20.2091 8 18 8L16 8", stroke: color, strokeWidth: "1.5", strokeLinecap: "round" }), react_1.default.createElement("path", { d: "M9 13L11.2929 15.2929C11.6834 15.6834 12.3166 15.6834 12.7071 15.2929L15 13", stroke: color, strokeWidth: "1.5", strokeLinecap: "round" }), react_1.default.createElement("path", { d: "M12 15L12 3", stroke: color, strokeWidth: "1.5", strokeLinecap: "round" })));
};
exports.DownloadIcon = DownloadIcon;
exports.default = exports.DownloadIcon;
